import { Chip, Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import useRides from "../services/useRides";

const columns = [
  { field: "id", headerName: "Ride ID", width: 100 },
  { field: "passenger_id", headerName: "Passenger", width: 120 },
  { field: "driver_id", headerName: "Driver", width: 120 },
  {
    field: "status",
    headerName: "Status",
    minWidth: 180,
    flex: 1,
    renderCell: ({ value }) => <Chip size="small" label={value} color={value === "trip_completed" ? "success" : "primary"} />,
  },
  { field: "estimated_price", headerName: "Est. Price", width: 120 },
  { field: "final_price", headerName: "Final Price", width: 120 },
  { field: "created_at", headerName: "Created At", flex: 1, minWidth: 220 },
];

export default function RidesPage() {
  const { rides, loading } = useRides();

  const rows = rides.map((ride) => ({
    id: ride.id,
    ...ride,
  }));

  return (
    <Stack spacing={2}>
      <Typography variant="h4" fontWeight={700}>
        Rides
      </Typography>
      <Paper sx={{ height: 560, borderRadius: 3, overflow: "hidden" }}>
        <DataGrid rows={rows} columns={columns} loading={loading} pageSizeOptions={[10, 25, 50]} />
      </Paper>
    </Stack>
  );
}
